import { LoadingAnimation } from "ss-lib";

const Loading = ({ msg }) => <div style={{width:"100vw", height:"100vh", marginTop:"40vh"}}><LoadingAnimation msg={msg} /></div>;

export default Loading;
